<template>
    <div>
        <div class="page-header">
            <el-page-header @back="goBack" :content="typetext"></el-page-header>
        </div>
        <!-- 选词填空 最新组件 -->
        <div class="content">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-weight: 700;">{{ specialty.title }}</span>
                    <!-- <el-button v-if="userInfo && userInfo.type == 1" @click="addWork" size="mini" type="primary">布置作业</el-button> -->
                    <el-button v-if="showrest()" type="primary" @click="rest" class="el-icon-refresh-right" size="small"> 重置</el-button>
                    <el-button :type="button_type" :loading="button_loading" @click="Coll" icon="el-icon-star-off" size="mini" circle></el-button>
                </div>
                <div class="question_box">
                    <div class="question_left">
                        <el-tabs v-model="specialtyname">
                            <el-tab-pane :label="typetext" name="first">
                                <div v-if="specialty.detail" class="directions"><span class="directions_title">Directions</span>: <div style="margin-top: 15px;text-indent: 30px;" v-html="specialty.detail"></div></div>
                                <form id="my-form">
                                    <div v-html="specialty.body" ></div>
                                    
                                </form>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div v-if="loading" class="question_right">
                        <el-tabs v-model="testname">
                            <el-tab-pane label="试题作答" name="first">
                                <div class="writing">

                                    <div class="answer_body" v-for="(item,index) in specialtytest" :key="index">
                                        <span style="line-height: 28px;display: inline-block;width: 100%;font-size: 15px;">{{ index+1 }} . {{ item.question }}</span>
                                        <el-input v-model="body[item.id]" placeholder="请在此处作答"></el-input>
                                    </div>

                                    <el-button class="submit" v-if="!form_data.student_id" type="primary" @click="submit" size="small">确认提交</el-button>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="答案解析" name="second">
                                <div class="first_question">
                                    <el-empty v-if="!isNotEmptyObject()" description="请先完成题目"></el-empty>
                                    <el-col v-if="isNotEmptyObject()" :span="22">
                                
                                        <div style="font-size: 14px;" v-html="specialty.analysis"></div>
                                        
                                        <div class="question_explain_box" v-for="(item,index) in specialtytest" :key="index">
                                            <span class="question_explain_box_title">问题{{ index+1 }} . {{ item.question }}</span>
                                            <span>参考答案：{{item.r_answer}}</span>
                                            <span>解析：{{ item.explain }}</span>
                                        </div>

                                    </el-col>
                                </div>
                                
                            </el-tab-pane>
        
                        </el-tabs>
                    </div>
                </div>
            </el-card>
        </div>
        <Arrangement :dialogVisible="dialogVisible" @success="back_success" @update:dialogVisible="updatedialogVisible" :wid="specialty.id" table="specialty_type"></Arrangement>
    </div>
</template>
<script>
import Http from "../../src/apis/specialty";
import arrangement from "../../untils/arrangement.vue";
import $ from 'jquery';  
export default {
    components:{
        'Arrangement':arrangement
    },
    props: {  
        form_data: {  
            type: Object,
        },
        userInfo:{
            type: Object,
        }
    },
    data(){
        return{
            button_loading:false,
            button_type:'info',
            specialtyname:'first',
            testname:'first',
            id:'',
            specialty:{},
            specialtytest:[],
            score:0,
            submitanswers:[],
            options:[],
            task_id:0,
            plan_id:0,
            periods:'',
            in_time:'',
            decipher:[],
            typetext:'',
            loading:false,
            body:{},
            dialogVisible:false,
            rules:{}
        }
    },
    computed: {  
        isNotEmptyObject() {  
            return function(obj) {
                if(this.rules.scorerules){
                    if(this.score >= this.rules.scorerules || this.rules.finsh){
                        return true;
                    }
                    return false;
                    
                }else{
                    if(this.rules.finsh){
                        return true;
                    }
                    return false;
                }
            };  
        },
        showrest(){
            return function(){
                if(((this.userInfo && this.userInfo.type == 0) && this.rules.flag) && !this.rules.finsh){
                    return true;
                }else{
                    return false;
                }
            }
        }
    },  
    mounted(){
        window.addEventListener('popstate', this.handlePopState);  
    },

    methods:{
        rest(){
            for (let key in this.body) {
                this.body[key] = '';
            }
        },
        addWork(){
            this.dialogVisible = true
        },
        updatedialogVisible(e){
            this.dialogVisible = e
        },
        back_success(){
            this.dialogVisible = false
        },
        handlePopState(){
            this.specialty = {}
            this.specialtytest = []
            this.loading = false
        },
        submit(){
            var params = {}
        

            for(var index in this.body){

                if(!this.body[index]){
                    this.$message({
                        showClose: true,
                        message: '请检查答案是否完整',
                        type: 'error'
                    });
                    return false;
                }

            }

            params.body = this.body

            params.w_id = this.form_data.id
            params.worktype = this.form_data.worktype
            params.table_type = 'specialty'
            params.source = 'PC'
            params.in_time = this.in_time
            params.task_id = this.form_data.task_id
            params.plan_id = this.form_data.plan_id
            params.periods = this.form_data.periods
            Http.Submit(params).then((res) => {
                if(res.code){
                    this.$alert(res.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    this.getData()
                }else{
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
            
        },
       

        getData(){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.4)'
            });
            var params = {}
            params.id = this.form_data.id
            if(this.form_data.student_id){
                params.student_id = this.form_data.student_id
            }
            Http.Detail(params).then((res) => {

                var answer = res.data.specialty_test;

                var body = {}

                for(var index in answer){
                    var value = Object.keys(res.data.submitanswers).length?res.data.submitanswers[answer[index].id]:''
                    body[answer[index].id] = value
              
                }
                this.body = body

                this.specialty = res.data.specialty
                this.specialtytest = res.data.specialty_test

                this.button_type = res.data.collection?'primary':'info'
                this.submitanswers = res.data.submitanswers
                this.in_time = res.data.time
                this.decipher = res.data.decipher
                this.score = res.data.score * 100
                this.typetext = res.data.typetext
                this.rules = res.data.rules
                this.loading = true
                loading.close()
                
            });

        },

        // 收藏
        Coll(){
            if(!this.userInfo){
                this.$router.push({name:'Login',query:{redirect:encodeURIComponent(window.location.href)}});
                return false;
            }
            this.button_loading = true
            var params = {}
            params.wid = this.form_data.id
            params.tabel_type = 'specialty'
            params.title = this.specialty.title
            Http.Coll(params).then((res) => {
                this.button_loading = false
                if(this.button_type == 'primary'){
                    this.button_type = 'info'
                }else{
                    this.button_type = 'primary'
                }

                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.code ? 'success' : 'error'
                });
                
            });
        },
        goBack(){
            window.history.back();
        },
    }
}
</script>
<style scoped>
.content{
    width: 1200px;
    margin: 0 auto;
}
.content >>> .el-card__header{
    display: inline-block;
    width: 100%;
}
.clearfix >>> .el-button{
    float: right;
    margin-left: 15px;
}
.clearfix span{
    float: left;
}
.question_box{

    width: 100%;
    height: 800px;
}
.question_left{
    width: 49%;
    float: left;
    height: 800px;
    overflow-y: auto;
    box-sizing: border-box;
}
.question_explain_box{
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    gap: 10px;
}
.question_explain_box_title{

    font-weight: 700;
    color: #000000;
}
.question_left::-webkit-scrollbar {  
  width: 10px; /* 滚动条的宽度 */  
}  
  
.question_left::-webkit-scrollbar-track {  
  background: rgba(0, 0, 0, 0); /* 滚动条轨道的背景色，设置透明度 */  
}  
  
.question_left::-webkit-scrollbar-thumb {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块的颜色，设置透明度 */  
  border-radius: 10px; /* 圆角效果 */  
}  
  
.question_left::-webkit-scrollbar-thumb:hover {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块hover时的颜色，设置透明度 */  
}
.question_left >>> .el-tabs__header{
    position: sticky;
    background: #ffffff;
    top: 0;
    z-index: 99;
}
.question_left >>> .el-tabs__content{

    padding: 0 20px;
}
.question_right{
    width: 50%;
    display: inline-block;
    height: 800px;
    overflow-y: auto;
}
.question_right >>> .el-tabs__header{
    position: sticky;
    background: #ffffff;
    top: 0;
    z-index: 99;
}
.question_right::-webkit-scrollbar {  
  width: 10px; /* 滚动条的宽度 */  
}  
  
.question_right::-webkit-scrollbar-track {  
  background: rgba(0, 0, 0, 0); /* 滚动条轨道的背景色，设置透明度 */  
}  
  
.question_right::-webkit-scrollbar-thumb {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块的颜色，设置透明度 */  
  border-radius: 10px; /* 圆角效果 */  
}  
  
.question_right::-webkit-scrollbar-thumb:hover {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块hover时的颜色，设置透明度 */  
}
.first_question {
    padding: 20px;
    width: 95%;
    display: inline-block;
    text-align: left;
    margin-bottom: 15px;
}
.first_question >>> .el-textarea__inner{
    min-height: 150px !important;
}
.first_question >>> .el-card__body{
    padding: 10px;
}
.first_question >>> .el-col{
    margin-top: 15px;
    font-size: 14px;
    line-height: 20px;
}
.first_question .question{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    line-height: 23px;
    display: inline-block;
}
.right{
    background: #75A3E4 !important;
    color: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}
.error{
    background: #FF6E6E !important;
    color: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}
.specialtytest{
    width: 100% !important;
}
.question_left form{

    text-align: center;
    font-size: 14px;
}
.question_left form div{
    text-align: left;
    line-height: 30px;
    font-size: 15px;
}

.submit{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #409eff;
    border: 1px solid #409eff;
    color: #ffffff;

    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    padding: 8px 15px;
    font-size: 14px;
    border-radius: 4px;
    margin-top: 40px;
}
.page-header{
    width: 1200px;
    background: #ffffff;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
}
.page-header >>> .el-page-header{
    line-height: 40px;
    padding: 5px 15px;
}
.page-header >>> .el-page-header__content{
    font-size: 15px;
}
.writing .el-textarea >>> .el-textarea__inner{
    min-height: 600px !important;
}
.directions{
    width: 100%;
    text-align: left;
    background: #F6F7FF;
    font-size: 14px;
    padding: 10px;
    border-radius: 7px;
    margin-bottom: 10px;
}
.directions_title{

    font-weight: 700;

}
.answer_body{
    display: inline-block;
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
    margin-right: 2%;
}


.answer_body >>> .el-input{

    width: 80%;
}

</style>